module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/tile_cocktailparty-5524206f1e067d6d7d594753f8210597.jpg";